import React from 'react'
import { Modal } from 'react-responsive-modal';
import {
  TitleProduct,
  SubTitleProduct,
  MiddleContainer,
} from "../../components/modal/style/FillRequiredModalStyle";
import ButtonComponent from "../Button";

import { Flex } from "../../styles/GlobalStyle";
import Property from '../../model/property';
import { withTranslation } from 'react-i18next';

const FillRequiredModal = ({ stateModal, openCloseModal,t }) => {
  return (
    <Modal open={stateModal} onClose={() => openCloseModal(!stateModal)} showCloseIcon={false} center>
      <ModalContent onCancel={() => openCloseModal(!stateModal)}
        children={t('PLEASE_FILL_OUT_REQUIRED')}
        t={t}
      />
    </Modal>
  )
}

export default withTranslation()(FillRequiredModal)

function ModalContent({ onCancel, children ,t}) {
  const preset = Property.getPreset()
  return (
    <MiddleContainer>
      <Flex flex={1} justifyContent={"center"}>
        <TitleProduct className={'modalTitle'}>{t('SORRY')}</ TitleProduct>
        <hr />
        <SubTitleProduct className={'modalSubtitle'}>{children}</SubTitleProduct>
        <SubTitleProduct></SubTitleProduct>
        <Flex container flex={1} alignItems={"center"} justifyContent={"center"}>
          <ButtonComponent padding={"0.25em 0"} width={"80%"} label={t('OK')} backgroundColor={preset.app_home_color_primary ? preset.app_home_color_primary : "black"} color={preset.text_color} borderRadius={"30px"} onClick={onCancel} />
        </Flex>
      </Flex>
    </MiddleContainer>
  )
}
